import { Box, HStack } from 'ui/Layout';
import Skeleton from 'ui/Skeleton';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import TopNavLogo from './TopNavLogo';
import UserSection from './UserSection';

type Props = {
  children?: React.ReactNode;
};

const TopNavBar: React.FC<Props> = ({ children }) => {
  const { isErrorFetching, isFetching } = useSankeyFormContext();
  return (
    <Box
      bg="gray.50"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
      w="100%"
    >
      <HStack
        alignItems="center"
        justifyContent="space-between"
        maxW="var(--chakra-breakpoints-xxl)"
        mx="auto"
        gap={4}
        pl={2}
        pr={3}
        py={2}
      >
        <HStack alignItems="center" minW="200px" gap={3}>
          <TopNavLogo />
          {isFetching ? (
            <Skeleton.Row w="150px" h="28px" />
          ) : isErrorFetching ? null : (
            children
          )}
        </HStack>
        <UserSection />
      </HStack>
    </Box>
  );
};

export default TopNavBar;
